export const defineCanGoBack = () => typeof window.history?.state === "object" && window.history?.state?.idx !== 0;
